import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  wind2ScadaManf,
  wind2ScadaManfDelete,
  wind2ScadaManfSave,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input } from 'antd'

const Wind2ScadaeManf = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const insertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 200px 200px 200px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            SCADA Manufacturer Id :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>SCADA Manufacturer Id :</Label> */}
        <Input
          value={insertData.windScadaManufacturerId}
          data-cy="manufacturerid"
          onChange={e =>
            setInsertData({
              ...insertData,
              windScadaManufacturerId: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            SCADA Manufacturer :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>SCADA Manufacturer :</Label> */}
        <Input
          value={insertData.windScadaManufacturer}
          data-cy="manufacturer"
          onChange={e =>
            setInsertData({
              ...insertData,
              windScadaManufacturer: e.target.value,
            })
          }
        />
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }
  return (
    <CommonScreen
      title="SCADA Manufacturer"
      header={Wind2ScadaManufacturerHeaders}
      sortOptions={Wind2ScadaManufacturerHeaders}
      saveTask={wind2ScadaManfSave}
      retrieveTask={wind2ScadaManf}
      deleteTask={wind2ScadaManfDelete}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      totalWidth={800}
      // heightOffset={100}
    />
  )
}

export default Wind2ScadaeManf
const Wind2ScadaManufacturerHeaders = [
  strCol({
    ident: 'windScadaManufacturerId',
    display: 'SCADA Manufacturer Id',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'windScadaManufacturer',
    display: 'SCADA Manufacturer',
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]
